/* keep track of state during rebuffers */
export const RebufferKeys = Object.freeze({
  TRACK_CAN_PLAY_SESSION_COUNT: 'TRACK_CAN_PLAY_SESSION_COUNT',
  TRACK_CAN_PLAY_TRACK_COUNT: 'TRACK_CAN_PLAY_TRACK_COUNT',
  DISPLAY_ADS_DURING_TRACK: 'DISPLAY_ADS_DURING_TRACK',
} as const);

export const RebufferActions = Object.freeze({
  INCREMENT_CAN_PLAY_COUNT: 'INCREMENT_CAN_PLAY_COUNT',
  RESET_TRACK_CAN_PLAY_COUNT: 'RESET_TRACK_CAN_PLAY_COUNT',
} as const);
